import React, {Component} from 'react'
import { createUrl, removeClassFromHtmlElement } from '../common/utils.js'
import t from '../i18n/salecomponents/index.js'

export const pageLinks = {
    wxcode: createUrl('html/wxcode'),
    ywtcode: createUrl('html/ywtcode'),
    ucenter: createUrl('html/usercenter'),
    pay: createUrl('html/pay'),
    purchase: createUrl('html/purchase'),
    book: createUrl('html/book'),
    psalebook: createUrl('html/psalebook'),
    businesscenter: createUrl('html/businesscenter')
};

export const configParams = {
    orderType: {
        grab: 0,
        fcode: 1,
        presale: 2,
        tqcode: 3,
        opensale: 4,
        mini: 4,
        business: 5
    }
};

export const reg = {
    phone: /^(13|14|15|16|17|18|19)[\d]{9}$/,
    phone_hk: /^\d{8}$/,
    recvAddress: /^([\u4E00-\u9FFF]|\d|[A-Z]|-|\s)+$/i,
    title: /^([\u4E00-\u9FFF]|\d|[A-Z]|-|\（|\）|\(|\)|\s){1,40}$/i, //发票抬头
    taxId: /^((\d|[A-Z]){15}|(\d|[A-Z]){18}|(\d|[A-Z]){20})$/i, //纳税人识别码
    email: /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/,
    telephone: /^(((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?|(13|14|15|16|17|18|19)[\d]{9})$/, // 电话 & 手机
    depositBank: /^[\u4E00-\u9FFF]{1,30}$/, // 开户银行
    bankAccount: /^\d{1,50}$/ //银行账号
}

export function closeTipPop() {
    this.setState({
        pop: null
    });
    removeClassFromHtmlElement()
}

export function TipPop(props) {
    const btn = props.btn ? props.btn : t('ok');
    const { msg } = props
    const dangerousInnerHTML = {
        __html: msg
    }
    return (
        <div className="oc-pop">
            <div className="oc-pop-wp">
                <div className="oc-pop-textbox oc-tb">
                    <div className="oc-pop-text oc-tb-cell">
                        {
                            msg.length <= 15
                                ? <h3>{msg}</h3>
                                : <div dangerouslySetInnerHTML={dangerousInnerHTML}></div>
                        }
                    </div>
                </div>
                <div className="oc-pop-btnbox">
                {
                    props.link
                        ? <a href={props.link} className="btn-oc">{btn}</a>
                        : <a href="javascript:;" className="btn-oc" onClick={props.onClose}>{btn}</a>
                }
                </div>
                { props.hideClose ? null : <a href="javascript:;" className="oc-pop-close" onClick={props.onClose}>t('close')</a> }
            </div>
        </div>
    )
}

export function TipLoadingPop(props) {
    return (
        <div className="oc-pop">
            <div className="oc-pop-wp">
                <div className="oc-pop-textbox oc-tb">
                    <div className="oc-pop-text oc-tb-cell">
                        {
                            props.msg.length <= 15
                                ? <h3>{props.msg}</h3>
                                : <div>{props.msg}</div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export class CountDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            day: 0,
            hour: 0,
            min: 0,
            secs: 0
        };
        this.Timer = null;
    }

    componentWillReceiveProps(props) {
        const { seconds } = props

        if (seconds !== this.props.seconds) {

            this.setState({
                day: ~~(seconds / 86400),
                hour: ~~(seconds % 86400 / 3600),
                min: ~~(seconds % 3600 / 60),
                secs: seconds % 60
            }, () => {
                clearInterval(this.Timer);
                this.Tick();
                this.Timer = setInterval(() => this.Tick(), 1000);
            });
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        clearInterval(this.Timer);
    }

    Tick() {
        let { day, hour, min, secs } = this.state;
        day = +day;
        hour = +hour
        min = +min;
        secs = +secs;
        if ( day === 0 && hour === 0 && min === 0 && secs === 0) {
            clearInterval(this.Timer);
            this.setState({
                day: '0',
                hour: '00',
                min: '00',
                secs: '00'
            });
            this.props.callback();
            return
        }  else if (day > 0 && hour === 0 && min === 0 && secs === 0) {
            day -= 1;
            hour = 23;
            min = 59;
            secs = 59;
        } else if (hour > 0 && min === 0 && secs === 0) {
            hour -= 1;
            min = 59;
            secs = 59;
        } else if (min >= 0) {
            if ( secs > 0 ) {
                secs -= 1
            } else if ( secs === 0 ) {
                min -= 1;
                secs = 59;
            }
        }

        this.setState({ day, hour, min, secs });
    }

    addZero(num) {
        num = +num;
        return num - 10 >= 0 ? num : '0' + num;
    }

    getTextDom() {
        const { day, hour, min, secs } = this.state
        if (day > 0) {
            return <h4>{t('please')}<span>{day}</span>天<span>{hour}</span>小时<span>{min}</span>{t('minutes')}<span>{secs}</span>{t('order_cancel')}</h4>
        }
        if (hour > 0) {
            return <h4>{t('please')}<span>{hour}</span>小时<span>{min}</span>{t('minutes')}<span>{secs}</span>{t('order_cancel')}</h4>
        }
        return <h4>{t('please')}<span>{min}</span>{t('minutes')}<span>{secs}</span>{t('order_cancel')}</h4>
    }

    getClockDom() {
        const { day, hour, min, secs } = this.state
        if (day > 0) {
            return <strong>{`${day}天${this.addZero(hour)}${t('hour')}${this.addZero(min)}${t('min')}${this.addZero(secs)}秒`}</strong>
        }
        return <strong>{`${this.addZero(hour)}:${this.addZero(min)}:${this.addZero(secs)}`}</strong>
    }

    getPayDom(canCancel = true) {
        const { day, hour, min } = this.state
        const minStr = this.addZero(min)
        const cancelTxt = canCancel ? ', 超时后将取消订单' : '';
        if (day > 0) return <h4>请在 <em className="oc-col-blue"><span>{day}</span>天<span>{hour}</span>小时<span>{minStr}</span>分</em> 内完成支付{cancelTxt}</h4>
        if (hour > 0) return <h4>请在 <em className="oc-col-blue"><span>{hour}</span>小时<span>{minStr}</span>分</em> 内完成支付{cancelTxt}</h4>
        return <h4>请在 <em className="oc-col-blue"><span>{minStr}</span>分</em> 内完成支付{cancelTxt}</h4>
    }

    render () {
        const { min, secs } = this.state
        const { orderTime, orderTimeUnit, format, isYWT } = this.props
        const units = {
            'm': t('minutes'),
            'h': '小时',
            'd': '天',
        }

        const disp = {
            clock: <p>{t('please')}<strong>{orderTime}{units[orderTimeUnit]}</strong>{t('pay_countdown')}{this.getClockDom()}</p>,
            text: this.getTextDom(),
            // wxcode: <h2>{ isYWT && '一网通支付' }<em>{t('please')}{min}{t('min')}{secs}{t('overtime_refresh')}</em></h2>,
            wxcode: <em>{ `支付倒计时：请在${min}分${secs}秒内完成支付，超时二维码将过期，请刷新页面重新获取` }</em>,
            pay: this.getPayDom(),
            mini: this.getPayDom(false)
        };

        return(
            <div>{disp[format]}</div>
        );
    }
}
CountDown.defaultProps = {
    callback: function() {},
    orderTime: 45,
    orderTimeUnit: 'm', // 分钟
    isYWT: false
}

export function getOneCloudDevice(data) {
    if (data.black_num) return {img: '/images/purchase/oc_pro_1.jpg', color: t('color_black')};
    if (data.blue_num) return {img: '/images/purchase/oc_pro_3.jpg', color: t('color_blue')};
    if (data.orange_num) return {img: '/images/purchase/oc_pro_2.jpg', color: t('color_orange')};
    return {img: '', color: ''};
}

export function jumpToLogin () {
    location.href = `${createUrl('html/login')}?jumpurl=${encodeURIComponent(location.href)}`;
}


// WEBPACK FOOTER //
// ./js/src/components/SaleComponents.js